/**
 * CHAT-2710: second action of the WhatsApp panel — opens the native /start
 * request form with from=chat-widget, cta_id, page and the service inferred
 * by the shared startHref builder. No new channel, no message is sent.
 */
import { startHref } from './ctaSource';

export const CHAT_REQUEST_LABEL: Record<string, string> = {
  en: 'Send a project request', fr: 'Envoyer une demande de projet', es: 'Enviar una solicitud de proyecto',
  ar: 'إرسال طلب مشروع', de: 'Projektanfrage senden', it: 'Invia una richiesta di progetto',
  pt: 'Enviar um pedido de projeto', nl: 'Projectaanvraag versturen', pl: 'Wyślij zapytanie o projekt',
  tr: 'Proje talebi gönderin', ru: 'Отправить запрос на проект', zh: '提交项目需求',
  ja: 'プロジェクトの依頼を送る', ko: '프로젝트 요청 보내기', sv: 'Skicka en projektförfrågan',
  da: 'Send en projektforespørgsel',
};

export function chatRequestHref(language: string, pathname: string): string {
  const lang = /^[a-z]{2}$/.test(language || '') ? language : 'en';
  const path = /^\/[a-z]{2}(\/|$)/.test(pathname || '') ? pathname.split('?')[0] : `/${lang}`;
  return startHref(lang, path, 'chat-widget', 'chat-widget-request');
}
